// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'triangle-mixed-right';

export const Component = () => (
  <path d='M24.522 23.558 12.26 1 0 23.558h24.521ZM12.262 3.059V22.6H1.63L12.262 3.06Z' />
);

export const viewBox = '0 0 25 25';
